<app-loading-spinner />
<app-toast-container />
<div [@routeAnimations]="getRouteAnimationData()">
  <router-outlet />
</div>
